var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"setDefaultRadio"},[_c('Radio',{attrs:{"label":_vm.label,"disabled":_vm.disabled},on:{"on-change":_vm.change},model:{value:(_vm.data),callback:function ($$v) {_vm.data=$$v},expression:"data"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }